import {createSlice} from '@reduxjs/toolkit';
import {DateTime} from 'luxon';
import {getBadgesData} from '../api';

const slice = createSlice({
	name: 'badges',
	initialState: {
		badgesData: [],
		eventBadgesData: [],
		lastUpdated: null,
	},
	reducers: {
		badgesChanged: (badges, action) => {
			badges.badgesData = action.payload;
			badges.lastUpdated = DateTime.now().toUTC().toISO();
		},
		eventBadgesDataChanged: (badges, action) => {
			badges.eventBadgesData = action.payload;
		},
	},
});

export const {badgesChanged, eventBadgesDataChanged} = slice.actions;

export default slice.reducer;

export const updateBadges = (payload) => async (dispatch, getState) => {
	try {
		if (payload?.data) {
			return dispatch({type: badgesChanged.type, payload: payload?.data});
		}

		const lastUpdated = getState().badges.lastUpdated;
		const lastFetch = DateTime.fromISO(lastUpdated);
		if (!payload?.forceUpdate && lastUpdated && lastFetch.plus({minutes: 1}) > DateTime.now()) return;

		let loadedData = (await getBadgesData()).data;
		dispatch({type: badgesChanged.type, payload: loadedData});
	} catch (error) {
		console.log(error);
	}
};

export const updateEventBadges = (wengeAttendee, payload) => async (dispatch, getState) => {
	try {
		if (payload?.data) {
			return dispatch({type: eventBadgesDataChanged.type, payload: payload?.data});
		}

		let loadedData = (await getBadgesData(wengeAttendee)).data;
		console.log(loadedData);
		dispatch({type: eventBadgesDataChanged.type, payload: loadedData});
	} catch (error) {
		console.log(error);
	}
};
